import type { AppErrorProps } from '../../types/errors/errors.types'

export class AppError extends Error {
  public status?: number
  public error?: string

  constructor({ status = 404, error, message }: AppErrorProps) {
    super(message)

    this.status = status
    this.error = error
  }
}
